const MODAL_CONTENT_SELECTOR = '[data-modal-scroll-container="true"]';

export const scrollModalContentToTop = () => {
  const scrollContainer = document.querySelector(MODAL_CONTENT_SELECTOR) as HTMLElement | null;

  if (!scrollContainer) {
    return;
  }

  requestAnimationFrame(() => {
    scrollContainer.scrollTo({ top: 0, behavior: 'auto' });
  });
};
